import {
    FETCH_TIME_SLOTS_REQUEST,
    FETCH_TIME_SLOTS_SUCCESS,
    FETCH_TIME_SLOTS_FAILURE,
  } from 'constants/TimeSlot';
  
  const initialState = {
    loading: false,
    availableSlots: [],
    error: null,
  };
  
  const TimeSlotReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TIME_SLOTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_TIME_SLOTS_SUCCESS:
        return {
          ...state,
          loading: false,
          availableSlots: action.payload,
        };
      case FETCH_TIME_SLOTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default TimeSlotReducer;